export default "__VITE_ASSET__DQw1Ez20__"